import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { NgStyle, NgClass } from '@angular/common';
@Component({
  selector: 'app-burger-button',
  templateUrl: './burger-button.component.html',
  styleUrls: ['./burger-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgStyle, NgClass],
})
export class BurgerButtonComponent {
  @Input() isOpen = false;
  @Input() color = '#000';
  @Input() size: 'small' | 'medium' | 'large' = 'medium';
  @Input() ariaLabel = 'Toggle navigation menu';
  @Input() className?: 'burger-button';
  @Output() toggle = new EventEmitter<boolean>();

  @ViewChild('focusBegin') focusBegin!: ElementRef;

  onClick() {
    this.toggle.emit(!this.isOpen);
  }
}
